import Box from "@mui/material/Box";
import { Link } from "react-router-dom";

const PictureAttach = ({ sm }) => {
  if (!sm.pictureAttach) return null;

  return (
    <Box
      component={Link}
      to="/image-full-screen"
      state={{ uri: sm.pictureAttach }}
      onClick={(event) => event.stopPropagation()}
      sx={{ display: "block", lineHeight: 0 }}
    >
      <Box
        component="img"
        src={sm.pictureAttach}
        alt="Imagem anexada"
        loading="lazy"
        sx={{
          maxWidth: { xs: 200, sm: 260 },
          maxHeight: 260,
          borderRadius: 2,
          objectFit: "cover",
        }}
      />
    </Box>
  );
};

export default PictureAttach;
